<div class="betriebe-page">
    <div class="list-title-row">
        <button *ngIf="showReturnButton" mat-icon-button color="accent" (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <h3 class="list-title">Betriebe ({{ (meineVvvos?.length || 0) + (freigegebeneVvvos?.length || 0) }})</h3>
        <span class="spacer"></span>
        <button
            [matMenuTriggerFor]="spaltenMenu"
            color="accent"
            mat-icon-button
            class="spalten-button"
            matTooltip="Spalten auswählen"
        >
            <mat-icon>view_week</mat-icon>
        </button>
        <mat-menu #spaltenMenu="matMenu">
            <div class="spalten-menu-content" (click)="$event.stopPropagation()">
                <button
                    mat-menu-item
                    *ngFor="let col of columns"
                    [disabled]="!canToggleColumn(col)"
                    (click)="$event.stopPropagation(); toggleColumn(col.key)"
                >
                    <mat-icon>{{ col.visible ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                    <span>{{ col.label }}</span>
                </button>
            </div>
        </mat-menu>
        <button (click)="vvvoAnlegen()" color="accent" mat-icon-button matTooltip="Betrieb hinzufügen">
            <mat-icon>add</mat-icon>
        </button>
    </div>
    <div class="view-switch-row">
        <button
            mat-button
            color="accent"
            [class.view-switch-active]="isSelectedView('meine')"
            (click)="selectView('meine')"
        >
            Meine Betriebe ({{ getMeineCount() }})
        </button>
        <button
            mat-button
            color="accent"
            [class.view-switch-active]="isSelectedView('freigegebene')"
            (click)="selectView('freigegebene')"
        >
            Freigegebene Betriebe ({{ getFreigegebeneCount() }})
        </button>
    </div>

    <div class="search-container">
        <mat-form-field appearance="outline" class="search-field">
            <mat-label>Betriebe durchsuchen...</mat-label>
            <input matInput placeholder="Betrieb, VVVO, Betriebsart, Adresse oder E-Mail" [formControl]="searchControl" />
            <span matSuffix class="search-suffix">
                <button mat-icon-button aria-label="Clear" *ngIf="searchControl.value" (click)="clearSearch()">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-icon class="search-suffix-icon">search</mat-icon>
            </span>
        </mat-form-field>
    </div>

    <div class="mobile-cards" *ngIf="isMobileScreen && getFilteredVvvos().length; else desktopOrEmpty">
        <div class="mobile-card" *ngFor="let c of getFilteredVvvos()">
            <div class="mobile-card__header">
                <div class="mobile-card__title-wrap">
                    <div class="mobile-card__title">{{ getBetriebText(c) || '-' }}</div>
                </div>
                <button mat-icon-button [matMenuTriggerFor]="vvvoMenu" class="options-button" matTooltip="Menü öffnen">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #vvvoMenu="matMenu" xPosition="before" yPosition="below">
                    <button mat-menu-item *ngIf="selectedView === 'meine'" (click)="editiereVvvo(c)">
                        <mat-icon>edit</mat-icon>
                        <span>Bearbeiten</span>
                    </button>
                    <button
                        mat-menu-item
                        *ngIf="selectedView === 'meine' && !hasExternTierarzt(c)"
                        (click)="externTierarztHinzufuegen(c)"
                    >
                        <mat-icon>person_add</mat-icon>
                        <span>Tierarzt hinzufügen</span>
                    </button>
                    <button
                        mat-menu-item
                        *ngIf="selectedView === 'meine' && hasExternTierarzt(c)"
                        (click)="externTierarztEditieren(c)"
                    >
                        <mat-icon>edit</mat-icon>
                        <span>Tierarzt editieren</span>
                    </button>
                    <button
                        mat-menu-item
                        *ngIf="selectedView === 'meine' && hasExternTierarzt(c)"
                        (click)="externTierarztEntfernen(c)"
                    >
                        <mat-icon>person_remove</mat-icon>
                        <span>Tierarzt entfernen</span>
                    </button>
                    <button mat-menu-item (click)="futtermittellieferantAendern(c)">
                        <mat-icon>local_shipping</mat-icon>
                        <span>Futtermittellieferant ändern</span>
                    </button>
                    <button mat-menu-item (click)="vvvoEntfernen(c)">
                        <mat-icon>delete</mat-icon>
                        <span>{{ selectedView === 'freigegebene' ? 'Freigabe entfernen' : 'Betrieb entfernen' }}</span>
                    </button>
                    <button mat-menu-item (click)="hitPinAktualisieren(c)">
                        <mat-icon>password</mat-icon>
                        <span>HIT-PIN aktualisieren</span>
                    </button>
                    <button mat-menu-item *kienePermission="[9999]" (click)="freigabeTierarztpraxis(c)">
                        <mat-icon>local_hospital</mat-icon>
                        <span>Tierarztpraxis Freigabe erteilen</span>
                    </button>
                    <button mat-menu-item *ngIf="c.email" (click)="sendMail(c)">
                        <mat-icon>email</mat-icon>
                        <span>E-Mail senden</span>
                    </button>
                </mat-menu>
            </div>
            <div class="mobile-card__grid">
                <div class="mobile-card__item" *ngFor="let col of getVisibleColumns()">
                    <span class="mobile-card__label">{{ col.label }}</span>
                    <ng-container [ngSwitch]="col.key">
                        <a
                            *ngSwitchCase="'email'"
                            [href]="'mailto:' + getRawValue(c, 'email')"
                            class="mobile-card__value"
                            [class.mobile-card__value--disabled]="!getRawValue(c, 'email')"
                            [attr.tabindex]="getRawValue(c, 'email') ? null : -1"
                        >
                            {{ getCellValue(c, 'email') }}
                        </a>
                        <a
                            *ngSwitchCase="'belege_email'"
                            [href]="'mailto:' + getRawValue(c, 'belege_email')"
                            class="mobile-card__value"
                            [class.mobile-card__value--disabled]="!getRawValue(c, 'belege_email')"
                            [attr.tabindex]="getRawValue(c, 'belege_email') ? null : -1"
                        >
                            {{ getCellValue(c, 'belege_email') }}
                        </a>
                        <a
                            *ngSwitchCase="'kp_abw_email'"
                            [href]="'mailto:' + getRawValue(c, 'kp_abw_email')"
                            class="mobile-card__value"
                            [class.mobile-card__value--disabled]="!getRawValue(c, 'kp_abw_email')"
                            [attr.tabindex]="getRawValue(c, 'kp_abw_email') ? null : -1"
                        >
                            {{ getCellValue(c, 'kp_abw_email') }}
                        </a>
                        <span *ngSwitchDefault class="mobile-card__value">{{ getCellValue(c, col.key) }}</span>
                    </ng-container>
                </div>
            </div>

            <button mat-stroked-button color="accent" class="mobile-card__more-button" (click)="toggleExpandedRow(c)">
                {{ isRowExpanded(c) ? 'Weniger Info' : 'Weitere Info' }}
            </button>

            <div class="mobile-card__expanded" [class.mobile-card__expanded--open]="isRowExpanded(c)">
                <div class="mobile-card__item">
                    <span class="mobile-card__label">Kunden-Nr</span>
                    <span class="mobile-card__value">{{ getCellValue(c, 'kunde_nr_intern') }}</span>
                </div>
                <div class="mobile-card__item">
                    <span class="mobile-card__label">Futtermittellieferant</span>
                    <span class="mobile-card__value">{{ getCellValue(c, 'futtermittellieferant') }}</span>
                </div>
                <div class="mobile-card__item">
                    <span class="mobile-card__label">Tierarzt</span>
                    <span class="mobile-card__value">{{ getCellValue(c, 'extern_tierarzt') }}</span>
                </div>
                <div class="mobile-card__item mobile-card__item--status">
                    <span class="mobile-card__label">Tierbewegung melden</span>
                    <mat-icon class="status-icon" [class.status-true]="toJaNein(c['tierbewegung_melden']) === 'Ja'">
                        {{ toJaNein(c['tierbewegung_melden']) === 'Ja' ? 'check_circle' : 'cancel' }}
                    </mat-icon>
                </div>
                <div class="mobile-card__item mobile-card__item--status">
                    <span class="mobile-card__label">Aktiv</span>
                    <mat-icon class="status-icon" [class.status-true]="toJaNein(c['aktiv']) === 'Ja'">
                        {{ toJaNein(c['aktiv']) === 'Ja' ? 'check_circle' : 'cancel' }}
                    </mat-icon>
                </div>
                <div class="mobile-card__item" *ngIf="showKommentar">
                    <span class="mobile-card__label">Kommentar</span>
                    <span class="mobile-card__value">{{ getCellValue(c, 'kommentar') }}</span>
                </div>
            </div>
        </div>
    </div>

    <ng-template #desktopOrEmpty>
        <div #tableScrollContainer class="list-wrapper" (scroll)="onTableHorizontalScroll()" *ngIf="getFilteredVvvos().length; else noVvvos">
        <div class="list-content" [style.min-width.px]="getDesktopMinWidthPx()">
            <div class="list-header" [ngStyle]="{ 'grid-template-columns': getDesktopGridTemplate() }">
                <button type="button" class="sortable-header" *ngFor="let col of getVisibleColumns()" (click)="setSort(col.key)">
                    <span>{{ col.label }}</span>
                    <mat-icon class="sort-icon" [class.active]="isSortKey(col.key)">{{ getSortIcon(col.key) }}</mat-icon>
                </button>
                <span class="row-actions row-actions-header"></span>
            </div>
            <ng-container *ngFor="let c of getFilteredVvvos()">
                <div class="list-row clickable-row" [ngStyle]="{ 'grid-template-columns': getDesktopGridTemplate() }" (click)="toggleExpandedRow(c)">
                    <span class="row-cell" *ngFor="let col of getVisibleColumns()">
                        <span class="mobile-field-label">{{ col.label }}:</span>
                        <ng-container [ngSwitch]="col.key">
                            <ng-container *ngSwitchCase="'bezeichnung'">
                                <span
                                    class="mobile-field-value betrieb-truncate"
                                    [matTooltip]="getBetriebText(c)"
                                    [matTooltipDisabled]="!showBetriebTooltip(c)"
                                >
                                    {{ getCellValue(c, col.key) }}
                                </span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'adresse'">
                                <span
                                    class="mobile-field-value betrieb-truncate"
                                    [matTooltip]="getVollAdresse(c)"
                                    [matTooltipDisabled]="!showAdresseTooltip(c)"
                                >
                                    {{ getCellValue(c, col.key) }}
                                </span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'email'">
                                <a
                                    #emailValueEl
                                    *ngIf="c.email; else noEmailValue"
                                    class="mobile-field-value"
                                    [href]="'mailto:' + c.email"
                                    (click)="$event.stopPropagation()"
                                    [matTooltip]="c.email"
                                    [matTooltipDisabled]="!isTextOverflow(emailValueEl)"
                                >
                                    {{ c.email }}
                                </a>
                                <ng-template #noEmailValue>
                                    <span class="mobile-field-value">-</span>
                                </ng-template>
                            </ng-container>
                        <ng-container *ngSwitchCase="'belege_email'">
                            <a
                                #belegeEmailValueEl
                                *ngIf="getRawValue(c, 'belege_email'); else noBelegeEmail"
                                class="mobile-field-value"
                                [href]="'mailto:' + getRawValue(c, 'belege_email')"
                                (click)="$event.stopPropagation()"
                                [matTooltip]="getRawValue(c, 'belege_email')"
                                [matTooltipDisabled]="!isTextOverflow(belegeEmailValueEl)"
                            >
                                {{ getRawValue(c, 'belege_email') }}
                            </a>
                            <ng-template #noBelegeEmail>
                                <span class="mobile-field-value">-</span>
                            </ng-template>
                        </ng-container>
                        <ng-container *ngSwitchCase="'kp_abw_email'">
                            <a
                                #kpAbwEmailValueEl
                                *ngIf="getRawValue(c, 'kp_abw_email'); else noKpAbwEmail"
                                class="mobile-field-value"
                                [href]="'mailto:' + getRawValue(c, 'kp_abw_email')"
                                (click)="$event.stopPropagation()"
                                [matTooltip]="getRawValue(c, 'kp_abw_email')"
                                [matTooltipDisabled]="!isTextOverflow(kpAbwEmailValueEl)"
                            >
                                {{ getRawValue(c, 'kp_abw_email') }}
                            </a>
                            <ng-template #noKpAbwEmail>
                                <span class="mobile-field-value">-</span>
                            </ng-template>
                        </ng-container>
                            <span
                                #defaultValueEl
                                *ngSwitchDefault
                                class="mobile-field-value"
                                [matTooltip]="getCellTooltip(c, col.key)"
                                [matTooltipDisabled]="!isTextOverflow(defaultValueEl)"
                            >
                                {{ getCellValue(c, col.key) }}
                            </span>
                        </ng-container>
                    </span>
                    <span class="row-actions">
                    <button mat-icon-button [matMenuTriggerFor]="vvvoMenu" class="options-button" matTooltip="Menü öffnen" (click)="$event.stopPropagation()">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #vvvoMenu="matMenu" xPosition="before" yPosition="below">
                            <button mat-menu-item *ngIf="selectedView === 'meine'" (click)="editiereVvvo(c)">
                                <mat-icon>edit</mat-icon>
                                <span>Bearbeiten</span>
                            </button>
                            <button
                                mat-menu-item
                                *ngIf="selectedView === 'meine' && !hasExternTierarzt(c)"
                                (click)="externTierarztHinzufuegen(c)"
                            >
                                <mat-icon>person_add</mat-icon>
                                <span>Tierarzt hinzufügen</span>
                            </button>
                            <button
                                mat-menu-item
                                *ngIf="selectedView === 'meine' && hasExternTierarzt(c)"
                                (click)="externTierarztEditieren(c)"
                            >
                                <mat-icon>edit</mat-icon>
                                <span>Tierarzt editieren</span>
                            </button>
                            <button
                                mat-menu-item
                                *ngIf="selectedView === 'meine' && hasExternTierarzt(c)"
                                (click)="externTierarztEntfernen(c)"
                            >
                                <mat-icon>person_remove</mat-icon>
                                <span>Tierarzt entfernen</span>
                            </button>
                            <button mat-menu-item (click)="futtermittellieferantAendern(c)">
                                <mat-icon>local_shipping</mat-icon>
                                <span>Futtermittellieferant ändern</span>
                            </button>
                            <button mat-menu-item (click)="vvvoEntfernen(c)">
                                <mat-icon>delete</mat-icon>
                                <span>{{ selectedView === 'freigegebene' ? 'Freigabe entfernen' : 'Betrieb entfernen' }}</span>
                            </button>
                        <button mat-menu-item (click)="hitPinAktualisieren(c)">
                            <mat-icon>password</mat-icon>
                            <span>HIT-PIN aktualisieren</span>
                        </button>
                            <button mat-menu-item *kienePermission="[9999]" (click)="freigabeTierarztpraxis(c)">
                                <mat-icon>local_hospital</mat-icon>
                                <span>Tierarztpraxis Freigabe erteilen</span>
                            </button>
                            <button mat-menu-item *ngIf="c.email" (click)="sendMail(c)">
                                <mat-icon>email</mat-icon>
                                <span>E-Mail senden</span>
                            </button>
                        </mat-menu>
                    </span>
                </div>
                <div
                    class="expanded-row-details"
                    [class.expanded-row-details-open]="isRowExpanded(c)"
                    [ngStyle]="{ 'grid-template-columns': getDesktopGridTemplate() }"
                >
                    <div class="expanded-item expanded-cell">
                        <div class="expanded-label">Kunden-Nr</div>
                        <div class="expanded-value">{{ getCellValue(c, 'kunde_nr_intern') }}</div>
                    </div>
                    <div class="expanded-item expanded-cell">
                        <div class="expanded-label">Futtermittellieferant</div>
                        <div class="expanded-value">{{ getCellValue(c, 'futtermittellieferant') }}</div>
                    </div>
                    <div class="expanded-item expanded-cell">
                        <div class="expanded-label">Tierarzt</div>
                        <div class="expanded-value">{{ getCellValue(c, 'extern_tierarzt') }}</div>
                    </div>
                    <div class="expanded-item expanded-cell">
                        <div class="expanded-label">Tierbewegung melden</div>
                        <div class="expanded-value">
                            <mat-icon class="status-icon" [class.status-true]="toJaNein(c['tierbewegung_melden']) === 'Ja'">
                                {{ toJaNein(c['tierbewegung_melden']) === 'Ja' ? 'check_circle' : 'cancel' }}
                            </mat-icon>
                        </div>
                    </div>
                    <div class="expanded-item expanded-cell">
                        <div class="expanded-label">Aktiv</div>
                        <div class="expanded-value">
                            <mat-icon class="status-icon" [class.status-true]="toJaNein(c['aktiv']) === 'Ja'">
                                {{ toJaNein(c['aktiv']) === 'Ja' ? 'check_circle' : 'cancel' }}
                            </mat-icon>
                        </div>
                    </div>
                    <div class="expanded-item expanded-cell" *ngIf="showKommentar">
                        <div class="expanded-label">Kommentar</div>
                        <div class="expanded-value">{{ getCellValue(c, 'kommentar') }}</div>
                    </div>
                    <span class="row-actions row-actions-header"></span>
                </div>
            </ng-container>
        </div>
        </div>
        <div
            #bottomScrollbar
            class="kiene-horizontal-scrollbar"
            [class.hidden]="!showHorizontalScrollbar"
            [style.left.px]="bottomScrollbarLeft"
            [style.width.px]="bottomScrollbarWidth"
            (scroll)="onBottomScrollbarScroll()"
        >
            <div class="kiene-horizontal-scrollbar-content" [style.width.px]="horizontalScrollWidth"></div>
        </div>
    </ng-template>

    <ng-template #noVvvos>
        <div class="empty-state">Keine Betriebe gefunden.</div>
    </ng-template>
</div>
